import { NavLink } from "react-router-dom";
import {
  Sun,
  Calendar as CalendarIcon,
  HeartPulse,
  ChefHat,
  MoreHorizontal,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

/**
 * SPEC 4.8 / 5.6 — mobile only, ~56pt, safe-area-aware. Five tabs:
 * Today · Calendar · Health · Kitchen · More. Active = accent dot.
 *
 * BW12.5: replaced Evidence with Kitchen. Evidence still reachable from /more.
 */

const TABS: { to: string; label: string; icon: LucideIcon }[] = [
  { to: "/", label: "Today", icon: Sun },
  { to: "/calendar", label: "Calendar", icon: CalendarIcon },
  { to: "/health", label: "Health", icon: HeartPulse },
  { to: "/kitchen", label: "Kitchen", icon: ChefHat },
  { to: "/more", label: "More", icon: MoreHorizontal },
];

export function BottomTabBar() {
  return (
    <nav
      aria-label="Primary"
      style={{
        position: "fixed",
        left: 0,
        right: 0,
        bottom: 0,
        height: `calc(var(--bottomtab-h) + env(safe-area-inset-bottom))`,
        paddingBottom: "env(safe-area-inset-bottom)",
        background: "var(--bg-2)",
        borderTop: "1px solid var(--hair)",
        display: "flex",
        zIndex: 20,
      }}
    >
      {TABS.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          end={t.to === "/"}
          style={({ isActive }) => ({
            flex: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 2,
            color: isActive ? "var(--fg)" : "var(--fg-3)",
            textDecoration: "none",
            fontSize: "var(--type-micro)",
            letterSpacing: "0.06em",
            textTransform: "uppercase",
            fontWeight: 500,
            position: "relative",
          })}
        >
          {({ isActive }) => (
            <>
              <t.icon
                size={20}
                strokeWidth={1.5}
              />
              <span style={{ marginTop: 2 }}>{t.label}</span>
              {isActive && (
                <span
                  aria-hidden
                  style={{
                    position: "absolute",
                    top: 6,
                    width: 4,
                    height: 4,
                    borderRadius: "50%",
                    background: "var(--accent)",
                  }}
                />
              )}
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
}
